import { render, staticRenderFns } from "./DataloadDelivery.vue?vue&type=template&id=a2c71e8c&"
import script from "./DataloadDelivery.vue?vue&type=script&lang=js&"
export * from "./DataloadDelivery.vue?vue&type=script&lang=js&"
import style0 from "./DataloadDelivery.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports